import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const SectionTitleRoot = styled(Type)`
  margin-bottom: ${({ theme }) => theme.space.sm};
  & p {
    margin: 0;
  }
`;
